import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface VNeIDVerifyingImages {
  cardFront: string;
  cardBack: string;
  faceScan: string;
  scanLine?: string;
}

export interface VNeIDVerifyingDialogData {
  title: string;
  description: string;
  images: VNeIDVerifyingImages;
}

export interface VNeIDVerifyingDialogOptions {
  title?: string;
  description?: string;
  images?: Partial<VNeIDVerifyingImages>;
}

export const VNEID_VERIFYING_DEFAULT_DATA: VNeIDVerifyingDialogData = {
  title: 'Đang xác thực dữ liệu',
  description:
    'Hệ thống đang tiến hành kiểm tra và đối chiếu dữ liệu bạn cung cấp. Vui lòng chờ trong giây lát...',
  images: {
    cardFront: 'assets/images/ekyc/ic_vneid_card_scan_bg.png',
    cardBack: 'assets/images/ekyc/ic_vneid_card_back_scan_bg.png',
    faceScan: 'assets/images/ekyc/ic_vneid_face_scan_bg.png',
    scanLine: 'assets/images/ekyc/ic_vneid_scan_line.png',
  },
};

@Component({
  selector: 'app-vneid-verifying-modal',
  templateUrl: './vneid-verifying-modal.component.html',
  styleUrls: ['./vneid-verifying-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VNeIDVerifyingModalComponent {
  constructor(
    public dialogRef: MatDialogRef<VNeIDVerifyingModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: VNeIDVerifyingDialogData
  ) {
    dialogRef.disableClose = true;
    const input = data || ({} as VNeIDVerifyingDialogOptions);
    this.data = {
      title: input.title || VNEID_VERIFYING_DEFAULT_DATA.title,
      description:
        input.description || VNEID_VERIFYING_DEFAULT_DATA.description,
      images: {
        ...VNEID_VERIFYING_DEFAULT_DATA.images,
        ...input.images,
      },
    };
  }

  close(result?: unknown): void {
    this.dialogRef.close(result);
  }
}
